<template>
  <div class="app-icon" v-on:click="$emit('click')" :class="`${isClickable ? 'hand-pointer' : 'hand-default'}`">
    <v-img :src="imageSrc" :class="path" v-bind="resetProps" class="icon" :contain="contain" :transition="false" />
    <span class="app-icon-title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "Icon",

  props: {
    type: {
      default: "button",
    },

    name: {
      default: null,
      type: String,
    },

    title: {
      default: null,
      type: String,
    },

    path: {
      default: "",
      type: String,
    },

    contain: {
      default: true,
      type: Boolean,
    },

    isClickable: {
      default: true,
      type: Boolean,
    },
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
    imageSrc() {
      return this.path ?? "";
    },
  },
};
</script>

<style lang="scss">
.app-icon {
  display: inline-block;

  &.hand-default {
    cursor: auto;
  }

  &.hand-pointer {
    cursor: pointer;
  }

  .v-btn--icon {
    width: initial !important;
    height: initial !important;
  }
}
</style>
